import { createSelector } from 'reselect';
import { getArmyCategories } from '../selector/getArmyCategories';
import { ArmyCategoryView } from './view/ArmyCategoryView';
import { VersionGame } from '@Models';
import { AppState } from '@Redux/store';
import { formValueSelector } from 'redux-form';

const getFormGame = (state: AppState): VersionGame => {
  const selector = formValueSelector('new_arsenal_army'); // <-- same as form name
  return (selector(state, 'game') ?? VersionGame.NinthAge) as VersionGame;
};

export const ArmyCategoriesPresenter = createSelector(
  [getArmyCategories, getFormGame],
  (armyCategories, game): Array<ArmyCategoryView> => {
    return armyCategories
      .filter((item) => !game || item.game === game)
      .map((item) => new ArmyCategoryView({ id: item.id, name: item.name }));
  },
);
